import React from "react";
import { PaRequirementsList } from "../components/PaRequirementsList";

export const LabSpecificPaRequirementsTab = () => {
  return <PaRequirementsList labSpecific={true} />;
};
